import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import LinearProgress from '@mui/material/LinearProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { Viruses } from './Viruses';
import { Developer } from './Developer';
import { TurnControl } from './TurnControl';
import { MachineLearning } from './MachineLearning';
import { apiFetch } from '../Helpers/api';

export function Gameboard(props) {

    const [setupOpen, setSetupOpen] = useState(true)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [players, setPlayers] = useState([])
    const [codebases, setCodebases] = useState([])
    const [playerInFocus, setPlayerInFocus] = useState(1)
    const [displaySetupError, setDisplaySetupError] = useState(false)

    useEffect(() => {
        apiFetch("codebases.php?scope=playtest")
            .then((res) => res.json())
            .then((json) => {
                const playerOptions = []
                ;(json.data || []).map((player) =>
                    playerOptions.push({codebaseId: parseInt(player.codebase_id), name: player.name, nickname: player.nickname, icon: player.icon})
                )
                setCodebases(playerOptions)
                if (props.codebaseId) {
                    const selectedCodebase = playerOptions.find((codebase) => String(codebase.codebaseId) === String(props.codebaseId));
                    if (selectedCodebase) {
                        setPlayers([selectedCodebase]);
                    }
                }
                setDataLoaded(true)
            })
    }, [props.codebaseId]) 

    function selectCodebase(event) {
        const selectedCodebase = codebases[Number(event.target.value)]
        let updatedList = [...players]
        if (event.target.checked) {
            updatedList = players.some((player) => player.codebaseId === selectedCodebase.codebaseId)
                ? players
                : [...players, selectedCodebase]
        } else {
            updatedList = players.filter((player) => player.codebaseId !== selectedCodebase.codebaseId)
        }
        updatedList.length < 1 ? setDisplaySetupError(true) : setDisplaySetupError(false)
        setPlayers(updatedList)
    }

    function finishSetup() {
        if (players.length > 0) {
            setPlayers([...players, {codebaseId: null, name: 'Machine Learning', nickname: 'Virus', icon: 'robot'}])
            setPlayerInFocus(players[0].codebaseId)
            setDisplaySetupError(false)
            setSetupOpen(false)
        } else {
            setDisplaySetupError(true)
        }
    }

    return (
            <>
            <Container className="main-content" maxWidth={false}>
                { dataLoaded && !setupOpen && players.length > 0 ?
                    <>
                    <Grid container spacing={4}> 
                        <Grid className='docs-nav' xs={12} sm={12} md={7}>
                        { players.length > 0 ? players.map((player, index) =>
                            player.codebaseId ? <Developer key={index} codebaseId={player.codebaseId} player={'player_' + index} inFocus={player.codebaseId === playerInFocus} />
                            : <MachineLearning key={index} inFocus={player.codebaseId === playerInFocus} /> 
                        ) : null }
                        </Grid>
                        <Grid xs={12} sm={12} md={5}> 
                            <Viruses startingViruses={players.length - 1} />
                        </Grid>
                    </Grid>            
                    </>
                    : null
                }
                    <Dialog
                        open={setupOpen}
                        onClose={finishSetup}
                        PaperProps={{sx: {bgcolor: 'black', border: 1, borderColor: 'white', padding: 3}}}
                        >
                            { dataLoaded ? 
                            <>
                                <div className='green-code' style={{fontSize: '1.2em', marginBottom: 10}}>Select Codebases to playtest:</div>
                                { codebases.length > 0 ? codebases.map((codebase, index) =>
                                    <div style={{textAlign: 'left'}} key={codebase.codebaseId}>
                                        <input
                                            type='checkbox'
                                            id={`codebase-${codebase.codebaseId}`}
                                            name={codebase.nickname}
                                            value={index}
                                            checked={players.some((player) => player.codebaseId === codebase.codebaseId)}
                                            onChange={selectCodebase}
                                        />
                                        <label className='white-code' htmlFor={`codebase-${codebase.codebaseId}`}>{codebase.name}</label><br/>
                                    </div>
                                ) : <div className='profile-empty'>no entitled codebases found</div> }
                                { displaySetupError && <div className='white-code' style={{color: 'red'}}>You must select at least one Codebase.</div> }
                                <DialogActions>
                                    <button className="cli-button" onClick={finishSetup}>play</button>
                                </DialogActions>
                            </>
                            : <LinearProgress color="success" /> }
                    </Dialog>
                { !(dataLoaded) &&
                    <LinearProgress color="success" />
                }
            </Container>
            { dataLoaded && !setupOpen && players.length > 0 ? <TurnControl players={players} playerInFocus={playerInFocus} setPlayerInFocus={setPlayerInFocus} /> : null }
            </>

    )   
}
